import React, { useEffect, useRef, useState } from "react";
import PosPage from "./Pages/PosPage";
import axios from "axios";
import { useDispatch, useSelector } from "react-redux";
import { createMenu } from "./Features/orderMenu";
import { error } from "console";
import { INITIALIZE_TABLE_AREA } from "./Features/cart";
import { RootState } from ".";
import { SET_DB } from "./Features/database";
// @ts-ignore
import PouchDB from "pouchdb";
import data from "./BW Complete Menu.json";
import LoginPage from "./Pages/LoginPage";
import KDSPage from "./Pages/KDSPage";
import { SET_POS_CONFIG, SET_SHORTCUTS_CONFIG } from "./Features/leftBarHeader";
import BarcodePrintPage from "./Pages/BarcodePrintPage";
import { IPosConfig } from "./Interfaces/IPosConfig";
import { BaseService } from "./assets/BaseService";

function App(): JSX.Element {
  const appRef = useRef<HTMLDivElement>(null);
  const dispatch = useDispatch();
  const db = useSelector((state: RootState) => state.database.db);
  const route = useSelector((state: RootState) => state.header.route);
  const slug = useSelector((state: RootState) => state.leftHeader.slug);
  const token = localStorage.getItem("access_token");
  const selectedHeader = useSelector(
    (state: RootState) => state.leftHeader.selectedHeader
  );
  const [configLoaded, setConfigLoaded] = useState(false);

  const screenFull =
    selectedHeader === "Orders";

  const snake_case_string = (str: string | null) => {
    return (
      str &&
      str
        .match(
          /[A-Z]{2,}(?=[A-Z][a-z]+[0-9]*|\b)|[A-Z]?[a-z]+[0-9]*|[A-Z]|[0-9]+/g
        )
        ?.map((s: string) => s.toLowerCase())
        .join("_")
    );
  };

  const convertJsonToFormat = (jsonData: IPosConfig) => {
    console.log("jsonData", jsonData);
    const result: any = {};
    if (jsonData !== undefined) {
      let keys = Object.keys(jsonData);
      for (let i = 0; i < keys.length; i++) {
        result[`${snake_case_string(keys[i].toString())}`] =
          jsonData[keys[i] as keyof IPosConfig];
      }
    }

    return result;
  };

  useEffect(() => {
    const loadPosConfig = async () => {
      try {
        const response = await fetch('/config.json');
        if (!response.ok) {
          throw new Error(`Failed to load config: ${response.status} ${response.statusText}`);
        }
        const configData = await response.json();
        const formattedData = convertJsonToFormat(configData);
        console.log("POS Config loaded from file:", formattedData);
        dispatch(SET_POS_CONFIG(formattedData));
        setConfigLoaded(true);
      } catch (error) {
        console.error("Error loading POS config from file:", error);
        // Fallback to API if file loading fails
        // loadPosConfigFromAPI();
      }
    };

    // const loadPosConfigFromAPI = async () => {
    //   try {
    //     const res = await BaseService.post(
    //       "https://bwapi.broadwaypizza.com.pk/dev/dynamicmongodb/get",
    //       { collection: "pos-config" },
    //       {}
    //     );
    //     const formattedData = convertJsonToFormat(res.data[0]);
    //     console.log("POS Config loaded from API:", formattedData);
    //     dispatch(SET_POS_CONFIG(formattedData));
    //     setConfigLoaded(true);
    //   } catch (error) {
    //     console.error("Error loading POS config from API:", error);
    //   }
    // };

    loadPosConfig();
  }, [dispatch]);

  // useEffect(() => {
  //   if (configLoaded) {
  //     const tokenAPIFunction = async () => {
  //       await BaseService.post(
  //         "https://bwapi.broadwaypizza.com.pk/dev/dynamicmongodb/get",
  //         { collection: "pos-config" },
  //         {}
  //       ).then((res) => {
  //         const formattedData = convertJsonToFormat(res.data[0]);
  //         console.log("formatted Data", formattedData);
  //         dispatch(SET_POS_CONFIG(formattedData));
  //       });
  //     };
  //     tokenAPIFunction();
  //   }
  // }, [configLoaded, token]);

  useEffect(() => {
    if (db === null) {
      dispatch(SET_DB(new PouchDB("orders")));
    }
  }, []);

  if (!configLoaded) {
    return (
      <div className="h-screen flex items-center justify-center bg-white">
        <div className="text-center">
          <div className="animate-spin rounded-full h-16 w-16 border-t-2 border-b-2 border-blue-500 mx-auto"></div>
          <p className="mt-4 text-lg font-semibold text-gray-700">Loading configuration...</p>
        </div>
      </div>
    );
  }

  return (
    <div className={`h-[100%] ${screenFull ? "" : "md:h-screen"}`}>
      <div className="bg-white h-[100%]" ref={appRef}>
        {route === "" && <LoginPage />}
        {route.search("/PosPage") >= 0 && <PosPage elementRef={appRef} />}
      </div>
    </div>
  );
}

export default App;

// data: '{"collection":"FeedbackApp","filter":{"slug":"feedback"}}',
